var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-fitout__sub-folders" },
    [
      _c(
        "Collapse",
        { attrs: { expand: !_vm.isAccepted } },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _c(
                "HKLLeftRight",
                { staticClass: "green-fitout-folders__title-box" },
                [
                  _c(
                    "div",
                    { staticClass: "green-fitout-folders__title-left" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.subFolder.displayOrder) +
                            ". " +
                            _vm._s(_vm.subFolder.value)
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isAccepted && _vm.canStartGreenFitout
                        ? _c(
                            "DottedMenu",
                            {
                              attrs: {
                                enableClickOutClose: true,
                                color: "darkblue",
                              },
                            },
                            [
                              _c("HKLButton", {
                                staticClass: "delete-button",
                                attrs: { action: "delete" },
                                on: { click: _vm.deleteModalOpen },
                              }),
                              _vm._v(" "),
                              _c("HKLModal", {
                                ref: "deleteModal",
                                attrs: {
                                  okBtnAction: "yesDelete",
                                  cancelBtnAction: "no",
                                  title: _vm.$t(
                                    "tenantProjects.greenFitOut.deleteAlert"
                                  ),
                                },
                                on: { onOkClick: _vm.deleteAction },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("HKLLeftRight", {
                    staticClass: "green-fitout-folders__title-right",
                    scopedSlots: _vm._u(
                      [
                        _vm.canViewPoint &&
                        typeof _vm.subFolder.point === "number"
                          ? {
                              key: "left",
                              fn: function () {
                                return [
                                  _c(
                                    "PencilEdit",
                                    {
                                      ref: "pointEditor",
                                      staticClass:
                                        "green-fitout-folders__point",
                                      attrs: {
                                        displayValue:
                                          _vm.subFolder.point +
                                          " " +
                                          _vm.$t(
                                            "tenantProjects.greenFitOut.pts"
                                          ),
                                        canEdit:
                                          _vm.canReviewGreenFitout &&
                                          !_vm.isSent,
                                      },
                                      on: {
                                        close: _vm.updatePoint,
                                        open: function () {
                                          return (_vm.inputData =
                                            _vm.subFolder.point)
                                        },
                                      },
                                    },
                                    [
                                      _c("HKLInput", {
                                        staticClass:
                                          "green-fitout-folders__point-input",
                                        on: {
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.pointEditorClose.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.inputData,
                                          callback: function ($$v) {
                                            _vm.inputData = $$v
                                          },
                                          expression: "inputData",
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "tenantProjects.greenFitOut.pts"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            }
                          : null,
                        {
                          key: "right",
                          fn: function () {
                            return [
                              _vm.isAccepted
                                ? _c("HKLStatusBadge", {
                                    attrs: {
                                      color: "light-green",
                                      value: _vm._f("uppercase")(
                                        _vm.$t("status.reviewed")
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isRejected
                                ? _c("HKLStatusBadge", {
                                    attrs: {
                                      color: "red",
                                      value: _vm._f("uppercase")(
                                        _vm.$t("status.rejected")
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            [
              _c(
                "div",
                { staticClass: "green-fitout-folders__description" },
                [
                  _vm.canStartGreenFitout && !_vm.isAccepted
                    ? _c(
                        "PencilEdit",
                        {
                          ref: "descriptionEditor",
                          attrs: {
                            displayValue:
                              _vm.subFolder.description ||
                              _vm.$t("project.docs.fillDescHint"),
                            canEdit: true,
                          },
                          on: {
                            dblclick: function () {
                              return _vm.descriptionEditorOpen()
                            },
                            close: _vm.updateDescription,
                            open: function () {
                              return (_vm.inputData =
                                _vm.subFolder.description || "")
                            },
                          },
                        },
                        [
                          _c("HKLInput", {
                            staticClass:
                              "green-fitout-folders__description-input",
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.descriptionEditorClose.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                            model: {
                              value: _vm.inputData,
                              callback: function ($$v) {
                                _vm.inputData = $$v
                              },
                              expression: "inputData",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.subFolder.description || "") +
                            "\n        "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isTenant && !_vm.isAccepted
                ? _c("HkldDropzone", {
                    attrs: {
                      sourceId: _vm.subFolder.sourceId,
                      metaData: { uploadOnTop: true },
                    },
                    on: { onCompleteQueue: _vm.addToNewDocList },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("EditAttachments", {
                attrs: {
                  sourceId: _vm.subFolder.sourceId,
                  canDownloadAll: true,
                  canDelete:
                    (_vm.canReviewGreenFitout && !_vm.isAccepted) ||
                    (_vm.isTenant && _vm.isRejected),
                  canEdit:
                    (_vm.canReviewGreenFitout || _vm.isTenant) &&
                    !_vm.isAccepted,
                  showDeleteBtnFunc: _vm.canDeleteAttachments,
                  uploadOnTop: true,
                  deleteFileCb: _vm.deleteFromNewDocList,
                },
                scopedSlots: _vm._u(
                  [
                    _vm.canReviewGreenFitout && !_vm.isAccepted
                      ? {
                          key: "buttons",
                          fn: function () {
                            return [
                              _c("HKLButton", {
                                attrs: {
                                  color: "darkblue",
                                  action: "rejectAction",
                                },
                                on: { click: _vm.rejectModalOpen },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: {
                                  color: "orange",
                                  action: "reviewedLock",
                                },
                                on: { click: _vm.acceptModalOpen },
                              }),
                              _vm._v(" "),
                              _c(
                                "HKLModal",
                                {
                                  ref: "rejectModal",
                                  attrs: {
                                    okBtnAction: "rejectAction",
                                    title: _vm.$t(
                                      "tenantProjects.greenFitOut.rejectAlert"
                                    ),
                                    beforeOkClick: _vm.formValidate,
                                  },
                                  on: { onOkClick: _vm.rejectAction },
                                },
                                [
                                  _c(
                                    "HKLForm",
                                    { ref: "form", staticClass: "text-input" },
                                    [
                                      _c("HKLTextarea", {
                                        directives: [
                                          {
                                            name: "fusioninputcheck",
                                            rawName: "v-fusioninputcheck",
                                            value: {
                                              type: "string",
                                              required: true,
                                            },
                                            expression:
                                              "{\n                  type: 'string',\n                  required: true\n                }",
                                          },
                                        ],
                                        model: {
                                          value: _vm.inputData,
                                          callback: function ($$v) {
                                            _vm.inputData = $$v
                                          },
                                          expression: "inputData",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLModal",
                                {
                                  ref: "acceptModal",
                                  staticClass:
                                    "green-fitout__sub-folders-accept-model",
                                  attrs: {
                                    okBtnAction: "confirmLock",
                                    title: _vm.$t(
                                      "tenantProjects.greenFitOut.acceptAlter"
                                    ),
                                    beforeOkClick: _vm.formValidate,
                                  },
                                  on: { onOkClick: _vm.acceptAction },
                                },
                                [
                                  _c(
                                    "HKLForm",
                                    { ref: "form" },
                                    [
                                      _c("HKLInput", {
                                        directives: [
                                          {
                                            name: "fusioninputcheck",
                                            rawName: "v-fusioninputcheck",
                                            value: {
                                              type: "string",
                                              required: true,
                                              pattern: _vm.numberChecker,
                                            },
                                            expression:
                                              "{\n                  type: 'string',\n                  required: true,\n                  pattern: numberChecker,\n                }",
                                          },
                                        ],
                                        model: {
                                          value: _vm.inputData,
                                          callback: function ($$v) {
                                            _vm.inputData = $$v
                                          },
                                          expression: "inputData",
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "tenantProjects.greenFitOut.points"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                      _c("p", { staticClass: "hint" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "tenantProjects.greenFitOut.acceptAlterHint"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("GreenFitOutSubFolderHistory", {
                attrs: { subFolder: _vm.subFolder },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }